<template>
  <v-dialog
    v-model="display"
    transition="dialog-right-transition"
    max-width="340px"
    hide-overlay
    persistent
    no-click-animation
    content-class="cookie-dialog"
  >
    <v-card
      color="white"
      class="cookie-card"
    >
      <p>
        <v-img
          :src="cookie"
          alt="cookie"
          width="50"
          class="d-inline-block vertical-align-middle mr-2"
        />
        <span class="cookie-title">
          {{ $t('public_layout.cookies.title') }}
        </span>
      </p>

      <p>
        {{ $t('public_layout.cookies.text') }}
      </p>

      <p>
        {{ $t('public_layout.cookies.learn_more') }}
        <router-link
          to="/privacy-policy"
          class="privacy-policy-link"
        >
          {{ $t('public_layout.cookies.privacy_policy') }}
        </router-link>
      </p>

      <v-btn
        color="primary"
        class="mr-4 px-8"
        @click.stop="accept"
      >
        {{ $t('public_layout.cookies.accept') }}
        <font-awesome-icon
          :icon="['fas', 'check']"
          class="ml-2"
        />
      </v-btn>

      <v-btn
        color="background"
        text
        plain
        @click.stop="decline"
      >
        {{ $t('public_layout.cookies.decline') }}
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import { useAuthStore } from '@/store/auth.module';
import { bootstrap } from 'vue-gtag';
import cookie from '@/assets/cookie.svg'

export default {
  name: 'CookieDialog',
  data() {
    return {
      cookie,
    };
  },
  computed: {
    isCookieAccepted() {
      const authStore = useAuthStore();
      return authStore.isCookieAccepted;
    },
    display() {
      return this.isCookieAccepted === null;
    },
  },
  methods: {
    accept() {
      const authStore = useAuthStore();
      authStore.acceptCookie();
      bootstrap().then(() => {});
    },
    decline() {
      const authStore = useAuthStore();
      authStore.declineCookie();
    },
  },
};
</script>

<style scoped lang="scss">
.cookie-card {
  padding: 20px;
  color: black !important;
}

.cookie-title {
  font-weight: bolder;
  font-size: 20px;
}

.privacy-policy-link {
  color: #214CF6 !important;
  font-weight: bold;
}
</style>
